import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type ConversationsPageStore } from 'pages/conversations/store/conversationsPageStore'

export const ConversationsPageContext = createContext<ConversationsPageStore | null>(null)

export const useConversationsPageContext = () => {
  const context = useContext(ConversationsPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ConversationsPageContext')

  return context
}

type IProviderConversationsPageProps = {
  value: ConversationsPageStore
  children: ReactNode
}

export const ProviderConversationsPage: FC<IProviderConversationsPageProps> = ({
  value,
  children,
}) => {
  return (
    <ConversationsPageContext.Provider value={value}>{children}</ConversationsPageContext.Provider>
  )
}
